import React, { useRef, useEffect } from "react";
import {
  FaArrowLeft,
  FaHotel,
  FaMapMarkerAlt,
  FaPhone,
  FaStar,
} from "react-icons/fa";

const VillaDetailsPopup = ({ hotel, onClose }) => {
  const modalRef = useRef();

  const toArray = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed;
      } catch {
        return value.split(",").map((v) => v.trim());
      }
    }
    if (typeof value === "object") return Object.values(value).map(String);
    return [String(value)];
  };

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 overflow-auto p-4">
      <div
        ref={modalRef}
        className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full relative animate-slide-up max-h-[90vh] overflow-y-auto"
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 left-4 text-indigo-600 hover:text-indigo-800 flex items-center z-10"
        >
          <FaArrowLeft className="mr-2" /> Close
        </button>

        {/* Banner Image */}
        <div className="relative">
          <img
            src={hotel.Photo}
            alt={hotel.RoomType}
            className="w-full h-64 object-cover rounded-t-2xl"
          />
          <div className="absolute bottom-2 right-2 bg-black bg-opacity-50 text-white px-3 py-1 rounded-full text-sm">
            {hotel.provider}
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <h2 className="text-3xl font-bold text-gray-900">{hotel.RoomType}</h2>
          <p className="flex items-center text-gray-600 mt-2">
            <FaMapMarkerAlt className="mr-2 text-green-600" /> {hotel.City}
          </p>
          <p className="flex items-center text-gray-500 text-[12px] mt-1">
            <FaHotel className="mr-1 text-green-600" /> {hotel.PropertyName}
          </p>
          <div className="flex items-center mt-4">
            <span className="flex items-center text-yellow-600 font-semibold text-lg">
              <FaStar className="mr-1" /> {hotel.AvgRating}
            </span>
            <span className="ml-4 text-gray-500">
              ({hotel.TotalReviews} reviews)
            </span>
            {hotel.tag && (
              <span className="ml-4 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm">
                {hotel.tag}
              </span>
            )}
          </div>

          <p className="text-2xl font-bold text-green-700 mt-4">
            ₹{hotel.pricePerNight ?? hotel.BaseTariff}{" "}
            <span className="text-gray-500 text-lg">/ night</span>
          </p>

          <div className="mt-4 text-gray-700">{hotel.Description}</div>

          {/* Amenities */}
          {hotel.Amenities && hotel.Amenities.length > 0 && (
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2 text-gray-800">
                Amenities
              </h3>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-gray-600">
                {toArray(hotel.Amenities).map((item, i) => (
                  <li key={i} className="flex items-center">
                    • {item}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {/* Room Details */}
          <div className="mt-6">
            <h3 className="text-xl font-bold mb-2 text-gray-800">
              Room Details
            </h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-gray-600">
              <li className="flex items-center">
                • Property Size : {hotel.Size}
              </li>
              <li className="flex items-center">
                • Maximum Occupancy : {hotel.MaxOccupancy}
              </li>
            </ul>
          </div>

          {/* Perks */}
          {/* <div className="mt-6">
            <h3 className="text-xl font-bold mb-2 text-gray-800">Perks</h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-gray-600">
              {toArray(hotel.perks).map((perk, i) => (
                <li key={i} className="flex items-center">• {perk}</li>
              ))}
            </ul>
          </div> */}

          {/* Contact */}
          <div className="mt-6 flex items-center text-gray-700 text-lg">
            <FaPhone className="mr-3 text-indigo-600" />
            <strong>Contact:</strong>&nbsp;
            {hotel.ContactNumber || "Not available"}
          </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={onClose}
                className="px-4 py-2 bg-[#2E4E33] text-white rounded hover:bg-[#2E4E33] transition"
              >
                Close
              </button></div>
        </div>
      </div>
    </div>
  );
};

export default VillaDetailsPopup;
